
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.75 3.75h22.5v19.5H.75Zm0 6h22.5","fill":"none","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M6.75 6V.75M17.25 6V.75M14.5 15.875a3.125 3.125 0 1 1-3.125-3.125 3.125 3.125 0 0 1 3.125 3.125Zm-.915 2.21 2.165 2.165","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    